<template>
  <v-container>
    <avs-card
      :noTitle="true"
      class="chat-window"
    >
      <template v-slot:content>
        <!-- Liste des questions -->
        <div v-if="showQuestionnaire">
          <v-list>
            <v-list-item
              v-for="(question, index) in questions"
              :key="index"
              @click="toggleQuestion(question)"
              :class="{ 'selected-question': selected.includes(question) }"
            >
              <v-list-item-content>{{ question }}</v-list-item-content>
              <v-icon
                right
                v-if="selected.includes(question)"
                >mdi-check</v-icon
              >
            </v-list-item>
          </v-list>
          <v-progress-circular
            v-if="loadingReport"
            indeterminate
            color="primary"
            size="40"
            class="my-4"
          />
          <v-btn
            v-else
            color="primary"
            class="mt-4"
            @click="generateReport"
            :disabled="selected.length === 0"
          >
            Générer le Rapport
          </v-btn>
        </div>

        <!-- Affichage du rapport généré -->
        <div v-if="generatedReport">
          <h3 class="mt-5">Rapport Généré</h3>
          <vue-editor v-model="generatedReport" />
          <v-btn
            color="success"
            class="mt-4"
            @click="saveReport"
            >Enregistrer</v-btn
          >
          <v-btn
            color="secondary"
            class="mt-4 ml-3"
            @click="exportPDF"
            >Exporter PDF</v-btn
          >
        </div>
      </template>
    </avs-card>
  </v-container>
</template>

<script>
import { VueEditor } from "vue2-editor"
import IaService from "@/services/IaService"

export default {
  name: "GenerateReport",
  components: { VueEditor },
  data() {
    return {
      questions: [
        "Quelle est la situation actuelle du projet ?",
        "Qui sont les membres de l'équipe projet ?",
        "Quelles sont les dates clés du projet",
        "Le projet est-il retardé ?",
        "Listez-moi les tâches en retard",
        "Combien d'inspections sont prévues ?",
        "Quel est le pourcentage de contrôles réalisés sans non-conformités ?",
        "Combien de non-conformités ont été détectées ?",
        "Pouvez-vous lister les non-conformités toujours ouvertes ?",
        "Énumérez-moi les mesures correctives en retard et à qui elles sont attribuées.",
        "Quelles sont les zones et les événements les plus fréquents dans les non-conformités ?",
        "Énumérer les causes racines des non-conformités",
        "Que dois-je faire pour éviter de futurs problèmes ?",
        "Faire un résumé du projet en 10 lignes"
      ],
      selected: [],
      generatedReport: "",
      loadingReport: false,
      showQuestionnaire: true
    }
  },
  computed: {
    companyId() {
      return this.$store.state.app.company?.pk
    },
    projectId() {
      return this.$store.state.app.project?.id
    }
  },
  mounted() {
    this.loadReportFromLocalStorage()
  },
  methods: {
    toggleQuestion(q) {
      if (this.selected.includes(q)) {
        this.selected = this.selected.filter(item => item !== q)
      } else {
        this.selected.push(q)
      }
    },
    saveReport() {
      const key = `report_${this.projectId}`
      localStorage.setItem(key, this.generatedReport)
      this.$store.commit("app/message", {
        message: "Rapport sauvegardé localement",
        type: "success"
      })
    },

    loadReportFromLocalStorage() {
      const key = `report_${this.projectId}`
      const stored = localStorage.getItem(key)
      if (stored) {
        this.generatedReport = stored
        this.showQuestionnaire = false // On affiche directement le rapport
      }
    },

    clearReportFromLocalStorage() {
      const key = `report_${this.projectId}`
      localStorage.removeItem(key)
      this.generatedReport = ""
    },
    async generateReport() {
      this.loadingReport = true
      try {
        const res = await IaService.generateReport(this.companyId, this.projectId, this.selected)
        this.generatedReport = res.report
        this.showQuestionnaire = false
      } catch (err) {
        this.$store.commit("app/message", {
          message: "Erreur lors de la génération du rapport",
          type: "error"
        })
      } finally {
        this.loadingReport = false
      }
    },
    goBackToQuestionnaire() {
      this.clearReportFromLocalStorage()
      this.selected = []
      this.showQuestionnaire = true
    },
    exportPDF() {
      const win = window.open("", "_blank")
      win.document.write(
        `<html><head><title>Rapport</title></head><body>${this.generatedReport}</body></html>`
      )
      win.document.close()
      win.print()
    }
  }
}
</script>

<style scoped>
.selected-question {
  background-color: #e3f2fd;
  font-weight: bold;
}

.chat-window {
  background-color: #f5f5f5;
  padding: 10px;
  border-radius: 10px;
}
</style>
